

































































import {
  Prop,
  Vue,
  Component,
  Watch
} from "@/shared/vuepack";
import { FetchState } from "@/shared/types";

@Component
export default class DrivewealthDisclosures extends Vue {
}
